<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item } from '../components/Item.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2021-06-06',
        major: [
          '12月チャンネル',
          '1月チャンネル',
          '共通',
        ],
        excepts: [
        ],
        items: [

          // [NOTE] KR
          // ================================================================================

          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-01',
            rare        : 'KR',
            name        : 'プレシャスミューズキラッとワンピ',
            imgUrl      : '/images/items/PCH5-01.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 1900,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-02',
            rare        : 'KR',
            name        : 'プレシャスミューズキラッとシューズ',
            imgUrl      : '/images/items/PCH5-02.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-03',
            rare        : 'KR',
            name        : 'プレシャスミューズキラッとヘアアクセ',
            imgUrl      : '/images/items/PCH5-03.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 900,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            rare        : 'KR',
          }),


          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-67',
            rare        : 'KR',
            name        : 'メルティックスターグループキラッとワンピ',
            imgUrl      : '/images/items/PCH5-67.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 1900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-68',
            rare        : 'KR',
            name        : 'メルティックスターグループキラッとシューズ',
            imgUrl      : '/images/items/PCH5-68.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'DW',
            type        : 'LO',
            point       : 900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-69',
            rare        : 'KR',
            name        : 'メルティックスターグループキラッとヘアアクセ',
            imgUrl      : '/images/items/PCH5-69.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'DW',
            type        : 'LO',
            point       : 900,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            rare        : 'KR',
          }),


          item({
            collection  : '1月チャンネル',
            id          : 'P-036',
            rare        : 'KR',
            name        : 'クールメルティックスターグループキラッとワンピ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=P-036',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 1900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'P-037',
            rare        : 'KR',
            name        : 'クールメルティックスターグループキラッとシューズ',
            imgUrl      : '/images/items/P-037.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'UQ',
            type        : 'CO',
            point       : 900,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'P-038',
            rare        : 'KR',
            name        : 'クールメルティックスターグループキラッとヘアアクセ',
            imgUrl      : '//via.placeholder.com/100/fff/666/?text=P-038',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'UQ',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            rare        : 'KR',
          }),


          // [NOTE] PR
          // ================================================================================

          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-04',
            rare        : 'PR',
            name        : 'シャイニースターホワイトトップス',
            imgUrl      : '/images/items/PCH5-04.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 850,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-05',
            rare        : 'PR',
            name        : 'シャイニースターホワイトスカート',
            imgUrl      : '/images/items/PCH5-05.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 800,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-06',
            rare        : 'PR',
            name        : 'シャイニースターホワイトシューズ',
            imgUrl      : '/images/items/PCH5-06.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-07',
            rare        : 'PR',
            name        : 'シャイニースターホワイトヘアアクセ',
            imgUrl      : '/images/items/PCH5-07.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'PM',
            type        : 'PR',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-08',
            rare        : 'PR',
            name        : 'プリティーリボンビビッドピンクトップス',
            imgUrl      : '/images/items/PCH5-08.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 2, usual: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-09',
            rare        : 'PR',
            name        : 'プリティーリボンビビッドピンクスカート',
            imgUrl      : '/images/items/PCH5-09.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-10',
            rare        : 'PR',
            name        : 'プリティーリボンビビッドピンクシューズ',
            imgUrl      : '/images/items/PCH5-10.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-11',
            rare        : 'PR',
            name        : 'プリティーリボンビビッドピンクヘアアクセ',
            imgUrl      : '/images/items/PCH5-11.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-70',
            rare        : 'PR',
            name        : 'おはないっぱいおしょうがつももいろトップス',
            imgUrl      : '/images/items/PCH5-70.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-71',
            rare        : 'PR',
            name        : 'おはないっぱいおしょうがつももいろパンツ',
            imgUrl      : '/images/items/PCH5-71.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-72',
            rare        : 'PR',
            name        : 'おはないっぱいおしょうがつももいろシューズ',
            imgUrl      : '/images/items/PCH5-72.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-73',
            rare        : 'PR',
            name        : 'おはないっぱいおしょうがつももいろヘアアクセ',
            imgUrl      : '/images/items/PCH5-73.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-74',
            rare        : 'PR',
            name        : 'じょうねつカウガールトップス',
            imgUrl      : '/images/items/PCH5-74.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'RB',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 3 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-75',
            rare        : 'PR',
            name        : 'じょうねつカウガールパンツ',
            imgUrl      : '/images/items/PCH5-75.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'RB',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-76',
            rare        : 'PR',
            name        : 'じょうねつカウガールシューズ',
            imgUrl      : '/images/items/PCH5-76.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-77',
            rare        : 'PR',
            name        : 'じょうねつカウガールヘアアクセ',
            imgUrl      : '/images/items/PCH5-77.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'RB',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] PR モーリーファンタジー限定
          // ================================================================================

          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-05',
            rare        : 'PR',
            name        : 'クリスマスサンタグリーントップス',
            imgUrl      : '/images/items/MF-05.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-06',
            rare        : 'PR',
            name        : 'クリスマスサンタグリーンスカート',
            imgUrl      : '/images/items/MF-06.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 800,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-07',
            rare        : 'PR',
            name        : 'クリスマスサンタグリーンシューズ',
            imgUrl      : '/images/items/MF-07.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 850,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),
          item({
            collection  : 'モーリーファンタジー限定',
            id          : 'MF-08',
            rare        : 'PR',
            name        : 'クリスマスサンタグリーンヘアアクセ',
            imgUrl      : '/images/items/MF-08.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SH',
            type        : 'LO',
            point       : 750,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: true,
          }),


          // [NOTE] SR
          // ================================================================================

          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-12',
            rare        : 'SR',
            name        : 'プリティーリボンビビッドブルートップス',
            imgUrl      : '/images/items/PCH5-12.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-13',
            rare        : 'SR',
            name        : 'プリティーリボンビビッドブルースカート',
            imgUrl      : '/images/items/PCH5-13.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-14',
            rare        : 'SR',
            name        : 'プリティーリボンビビッドブルーシューズ',
            imgUrl      : '/images/items/PCH5-14.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-15',
            rare        : 'SR',
            name        : 'プリティーリボンビビッドブルーヘアアクセ',
            imgUrl      : '/images/items/PCH5-15.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-16',
            rare        : 'SR',
            name        : 'プリティーリボンビビッドグリーントップス',
            imgUrl      : '/images/items/PCH5-16.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-17',
            rare        : 'SR',
            name        : 'プリティーリボンビビッドグリーンスカート',
            imgUrl      : '/images/items/PCH5-17.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-18',
            rare        : 'SR',
            name        : 'プリティーリボンビビッドグリーンシューズ',
            imgUrl      : '/images/items/PCH5-18.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-19',
            rare        : 'SR',
            name        : 'プリティーリボンビビッドグリーンヘアアクセ',
            imgUrl      : '/images/items/PCH5-19.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-78',
            rare        : 'SR',
            name        : 'ドレッシーストライプレッドトップス',
            imgUrl      : '/images/items/PCH5-78.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-79',
            rare        : 'SR',
            name        : 'ドレッシーストライプレッドスカート',
            imgUrl      : '/images/items/PCH5-79.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-80',
            rare        : 'SR',
            name        : 'ドレッシーストライプレッドシューズ',
            imgUrl      : '/images/items/PCH5-80.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-81',
            rare        : 'SR',
            name        : 'ドレッシーストライプレッドヘアアクセ',
            imgUrl      : '/images/items/PCH5-81.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-82',
            rare        : 'SR',
            name        : 'たそがれカウガールトップス',
            imgUrl      : '/images/items/PCH5-82.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'RB',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-83',
            rare        : 'SR',
            name        : 'たそがれカウガールパンツ',
            imgUrl      : '/images/items/PCH5-83.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-84',
            rare        : 'SR',
            name        : 'たそがれカウガールシューズ',
            imgUrl      : '/images/items/PCH5-84.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'RB',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-85',
            rare        : 'SR',
            name        : 'たそがれカウガールヘアアクセ',
            imgUrl      : '/images/items/PCH5-85.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'RB',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),



          // [NOTE] R
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'PCH5-21',
            rare        : 'R',
            name        : 'エレガントパーティーブルートップス',
            imgUrl      : '/images/items/PCH5-21.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-22',
            rare        : 'R',
            name        : 'エレガントパーティーブルースカート',
            imgUrl      : '/images/items/PCH5-22.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-23',
            rare        : 'R',
            name        : 'エレガントパーティーブルーシューズ',
            imgUrl      : '/images/items/PCH5-23.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-24',
            rare        : 'R',
            name        : 'エレガントパーティーブルーヘアアクセ',
            imgUrl      : '/images/items/PCH5-24.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH5-25',
            rare        : 'R',
            name        : 'ボリュームファーピンクトップス',
            imgUrl      : '/images/items/PCH5-25.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-26',
            rare        : 'R',
            name        : 'ボリュームファーパープルスカート',
            imgUrl      : '/images/items/PCH5-26.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-27',
            rare        : 'R',
            name        : 'ボリュームファーピンクシューズ',
            imgUrl      : '/images/items/PCH5-27.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-28',
            rare        : 'R',
            name        : 'ボリュームファーピンクヘアアクセ',
            imgUrl      : '/images/items/PCH5-28.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH5-29',
            rare        : 'R',
            name        : 'クロックモダンモスグリーントップス',
            imgUrl      : '/images/items/PCH5-29.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-30',
            rare        : 'R',
            name        : 'クロックモダンモスグリーンスカート',
            imgUrl      : '/images/items/PCH5-30.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'SA',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-31',
            rare        : 'R',
            name        : 'クロックモダンモスグリーンシューズ',
            imgUrl      : '/images/items/PCH5-31.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-32',
            rare        : 'R',
            name        : 'クロックモダンモスグリーンヘアアクセ',
            imgUrl      : '/images/items/PCH5-32.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH5-33',
            rare        : 'R',
            name        : 'ローズ＆レースゴールドワンピ',
            imgUrl      : '/images/items/PCH5-33.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : 'PM',
            type        : 'PR',
            point       : 900,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-34',
            rare        : 'R',
            name        : 'ローズ＆レースゴールドシューズ',
            imgUrl      : '/images/items/PCH5-34.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-35',
            rare        : 'R',
            name        : 'ローズ＆レースゴールドヘアアクセ',
            imgUrl      : '/images/items/PCH5-35.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            rare        : 'R',
          }),


          // [NOTE] N
          // ================================================================================

          item({
            collection  : '共通',
            id          : 'PCH5-36',
            rare        : 'N',
            name        : 'チェッカーガールネイビートップス',
            imgUrl      : '/images/items/PCH5-36.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-37',
            rare        : 'N',
            name        : 'チェッカーガールネイビースカート',
            imgUrl      : '/images/items/PCH5-37.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-38',
            rare        : 'N',
            name        : 'チェッカーガールネイビーシューズ',
            imgUrl      : '/images/items/PCH5-38.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-39',
            rare        : 'N',
            name        : 'チェッカーガールネイビーヘアアクセ',
            imgUrl      : '/images/items/PCH5-39.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'GY',
            type        : 'PO',
            point       : 300,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH5-40',
            rare        : 'N',
            name        : 'チェッカーガールブラウントップス',
            imgUrl      : '/images/items/PCH5-40.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : 'GY',
            type        : 'PO',
            point       : 400,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-41',
            rare        : 'N',
            name        : 'チェッカーガールブラウンスカート',
            imgUrl      : '/images/items/PCH5-41.png',
            kind        : 'ボトムス',
            color       : '茶',
            brand       : 'GY',
            type        : 'PO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-42',
            rare        : 'N',
            name        : 'チェッカーガールブラウンシューズ',
            imgUrl      : '/images/items/PCH5-42.png',
            kind        : 'シューズ',
            color       : '茶',
            brand       : 'GY',
            type        : 'PO',
            point       : 300,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-43',
            rare        : 'N',
            name        : 'チェッカーガールブラウンヘアアクセ',
            imgUrl      : '/images/items/PCH5-43.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : 'GY',
            type        : 'PO',
            point       : 300,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH5-44',
            rare        : 'N',
            name        : 'ハッピークッキースカイブルートップス',
            imgUrl      : '/images/items/PCH5-44.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-45',
            rare        : 'N',
            name        : 'ハッピークッキースカイブルースカート',
            imgUrl      : '/images/items/PCH5-45.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-46',
            rare        : 'N',
            name        : 'ハッピークッキースカイブルーシューズ',
            imgUrl      : '/images/items/PCH5-46.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-47',
            rare        : 'N',
            name        : 'ハッピークッキースカイブルーヘアアクセ',
            imgUrl      : '/images/items/PCH5-47.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '共通',
            id          : 'PCH5-48',
            rare        : 'N',
            name        : 'ホワイトニットウィンタートップス',
            imgUrl      : '/images/items/PCH5-48.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 350,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-49',
            rare        : 'N',
            name        : 'ふんわりデニムウィンタースカート',
            imgUrl      : '/images/items/PCH5-49.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'SH',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-50',
            rare        : 'N',
            name        : 'もこもこウィンターブーツ',
            imgUrl      : '/images/items/PCH5-50.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 400,
            numOwned    : { usual: 8 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-51',
            rare        : 'N',
            name        : 'ふんわりリボンウィンターヘアアクセ',
            imgUrl      : '/images/items/PCH5-51.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 300,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] パシャッとアイテム
          // ================================================================================

          item({
            collection  : '12月チャンネル',
            id          : 'PCH5-20',
            rare        : 'SR',
            name        : 'クラシックヴァイオリン',
            imgUrl      : '/images/items/PCH5-20.png',
            kind        : 'パシャッとアイテム',
            color       : '茶',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '12月チャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '12月チャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '12月チャンネル',
            kind        : 'パシャッとアイテム',
          }),


          item({
            collection  : '1月チャンネル',
            id          : 'PCH5-86',
            rare        : 'SR',
            name        : 'あったかシチュー',
            imgUrl      : '/images/items/PCH5-86.png',
            kind        : 'パシャッとアイテム',
            color       : '赤',
            brand       : 'GY',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '1月チャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '1月チャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : '1月チャンネル',
            kind        : 'パシャッとアイテム',
          }),


          item({
            collection  : '共通',
            id          : 'PCH5-52',
            rare        : 'R',
            name        : 'きらきらピンクネイル',
            imgUrl      : '/images/items/PCH5-52.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : 'SH',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-53',
            rare        : 'R',
            name        : 'ビッグ☆ベア',
            imgUrl      : '/images/items/PCH5-53.png',
            kind        : 'パシャッとアイテム',
            color       : '茶',
            brand       : 'DW',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            id          : 'PCH5-54',
            rare        : 'R',
            name        : 'デリシャスナイフ&フォーク',
            imgUrl      : '/images/items/PCH5-54.png',
            kind        : 'パシャッとアイテム',
            color       : '銀',
            brand       : 'PM',
            type        : 'PR',
            point       : 450,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '共通',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] ブランドチャンネル
          // ================================================================================

          item({
            collection  : 'Secret Alice チャンネル',
            id          : 'SA-09',
            rare        : 'SR',
            name        : 'クロックモダンパープルトップス',
            imgUrl      : '/images/items/SA-09.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Secret Alice チャンネル',
            id          : 'SA-10',
            rare        : 'SR',
            name        : 'クロックモダンパープルスカート',
            imgUrl      : '/images/items/SA-10.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SA',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Secret Alice チャンネル',
            id          : 'SA-11',
            rare        : 'SR',
            name        : 'クロックモダンパープルシューズ',
            imgUrl      : '/images/items/SA-11.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Secret Alice チャンネル',
            id          : 'SA-12',
            rare        : 'SR',
            name        : 'クロックモダンパープルヘアアクセ',
            imgUrl      : '/images/items/SA-12.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : 'SA',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Universe Queen チャンネル',
            id          : 'UQ-08',
            rare        : 'SR',
            name        : 'ファンキーファーグリーントップス',
            imgUrl      : '/images/items/UQ-08.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'UQ',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Universe Queen チャンネル',
            id          : 'UQ-09',
            rare        : 'SR',
            name        : 'ファンキーファーグリーンパンツ',
            imgUrl      : '/images/items/UQ-09.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Universe Queen チャンネル',
            id          : 'UQ-10',
            rare        : 'SR',
            name        : 'ファンキーファーグリーンシューズ',
            imgUrl      : '/images/items/UQ-10.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Universe Queen チャンネル',
            id          : 'UQ-11',
            rare        : 'SR',
            name        : 'ファンキーファーグリーンヘアアクセ',
            imgUrl      : '/images/items/UQ-11.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : 'UQ',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Precious Muse チャンネル',
            id          : 'PM-01',
            rare        : 'SR',
            name        : 'エレガントパーティーイエロートップス',
            imgUrl      : '/images/items/PM-01.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Precious Muse チャンネル',
            id          : 'PM-02',
            rare        : 'SR',
            name        : 'エレガントパーティーイエロースカート',
            imgUrl      : '/images/items/PM-02.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Precious Muse チャンネル',
            id          : 'PM-03',
            rare        : 'SR',
            name        : 'エレガントパーティーイエローシューズ',
            imgUrl      : '/images/items/PM-03.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Precious Muse チャンネル',
            id          : 'PM-04',
            rare        : 'SR',
            name        : 'エレガントパーティーイエローヘアアクセ',
            imgUrl      : '/images/items/PM-04.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'Precious Muse チャンネル',
            id          : 'PM-05',
            rare        : 'SR',
            name        : 'ドレッシーストライプブルートップス',
            imgUrl      : '/images/items/PM-05.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'PM',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Precious Muse チャンネル',
            id          : 'PM-06',
            rare        : 'SR',
            name        : 'ドレッシーストライプブルースカート',
            imgUrl      : '/images/items/PM-06.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'PM',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Precious Muse チャンネル',
            id          : 'PM-07',
            rare        : 'SR',
            name        : 'ドレッシーストライプブルーシューズ',
            imgUrl      : '/images/items/PM-07.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'Precious Muse チャンネル',
            id          : 'PM-08',
            rare        : 'SR',
            name        : 'ドレッシーストライプブルーヘアアクセ',
            imgUrl      : '/images/items/PM-08.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : 'PM',
            type        : 'PR',
            point       : '00',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] なかよしチャンネル
          // ================================================================================

          item({
            collection  : 'なかよしチャンネル',
            id          : 'PCH5-106',
            rare        : 'SR',
            name        : 'クラシックホワイトヴァイオリン',
            imgUrl      : '/images/items/PCH5-106.png',
            kind        : 'パシャッとアイテム',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'なかよしチャンネル',
            rare        : 'SR',
          }),
          item({
            collection  : 'なかよしチャンネル',
            rare        : 'SR',
          }),
          item({
            collection  : 'なかよしチャンネル',
            rare        : 'SR',
          }),


          // [NOTE] マジマジョピュアーズ！コラボ
          // ================================================================================

          item({
            collection  : 'マジマジョピュアーズ！コラボ',
            id          : 'PCH5-63',
            rare        : 'SR',
            name        : 'マジマジョピュアーズ！モモカトップス',
            imgUrl      : '/images/items/PCH5-63.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'マジマジョピュアーズ！コラボ',
            id          : 'PCH5-64',
            rare        : 'SR',
            name        : 'マジマジョピュアーズ！モモカスカート',
            imgUrl      : '/images/items/PCH5-64.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'マジマジョピュアーズ！コラボ',
            id          : 'PCH5-65',
            rare        : 'SR',
            name        : 'マジマジョピュアーズ！モモカシューズ',
            imgUrl      : '/images/items/PCH5-65.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'マジマジョピュアーズ！コラボ',
            id          : 'PCH5-66',
            rare        : 'SR',
            name        : 'マジマジョピュアーズ！モモカヘアアクセ',
            imgUrl      : '/images/items/PCH5-66.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] 星のカービィコラボ
          // ================================================================================

          item({
            collection  : '星のカービィコラボ',
            id          : 'PCH5-102',
            rare        : 'SR',
            name        : 'カービィピンクパフィワンピ',
            imgUrl      : '/images/items/PCH5-102.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 1200,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '星のカービィコラボ',
            id          : 'PCH5-103',
            rare        : 'SR',
            name        : 'カービィピンクパフィシューズ',
            imgUrl      : '/images/items/PCH5-103.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '星のカービィコラボ',
            id          : 'PCH5-104',
            rare        : 'SR',
            name        : 'カービィピンクパフィベレー',
            imgUrl      : '/images/items/PCH5-104.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '星のカービィコラボ',
            id          : 'PCH5-105',
            rare        : 'SR',
            name        : 'スターロッド',
            imgUrl      : '/images/items/PCH5-105.png',
            kind        : 'パシャッとアイテム',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] クリスマスコーデキャンペーン
          // ================================================================================

          item({
            collection  : 'クリスマスコーデキャンペーン',
            id          : 'PCH5-55',
            rare        : 'SR',
            name        : 'クリスマスサンタレッドトップス',
            imgUrl      : '/images/items/PCH5-55.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'クリスマスコーデキャンペーン',
            id          : 'PCH5-56',
            rare        : 'SR',
            name        : 'クリスマスサンタレッドスカート',
            imgUrl      : '/images/items/PCH5-56.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'クリスマスコーデキャンペーン',
            id          : 'PCH5-57',
            rare        : 'SR',
            name        : 'クリスマスサンタレッドシューズ',
            imgUrl      : '/images/items/PCH5-57.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'クリスマスコーデキャンペーン',
            id          : 'PCH5-58',
            rare        : 'SR',
            name        : 'クリスマスサンタレッドヘアアクセ',
            imgUrl      : '/images/items/PCH5-58.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 1 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'クリスマスコーデキャンペーン',
            id          : 'PCH5-59',
            rare        : 'SR',
            name        : 'クリスマスサンタホワイトトップス',
            imgUrl      : '/images/items/PCH5-59.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'クリスマスコーデキャンペーン',
            id          : 'PCH5-60',
            rare        : 'SR',
            name        : 'クリスマスサンタホワイトスカート',
            imgUrl      : '/images/items/PCH5-60.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'クリスマスコーデキャンペーン',
            id          : 'PCH5-61',
            rare        : 'SR',
            name        : 'クリスマスサンタホワイトシューズ',
            imgUrl      : '/images/items/PCH5-61.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'クリスマスコーデキャンペーン',
            id          : 'PCH5-62',
            rare        : 'SR',
            name        : 'クリスマスサンタホワイトヘアアクセ',
            imgUrl      : '/images/items/PCH5-62.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] おしょうがつコーデキャンペーン
          // ================================================================================

          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-87',
            rare        : 'SR',
            name        : 'おはないっぱいおしょうがつふじいろトップス',
            imgUrl      : '/images/items/PCH5-87.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-88',
            rare        : 'SR',
            name        : 'おはないっぱいおしょうがつふじいろパンツ',
            imgUrl      : '/images/items/PCH5-88.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-89',
            rare        : 'SR',
            name        : 'おはないっぱいおしょうがつふじいろシューズ',
            imgUrl      : '/images/items/PCH5-89.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-90',
            rare        : 'SR',
            name        : 'おはないっぱいおしょうがつふじいろヘアアクセ',
            imgUrl      : '/images/items/PCH5-90.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-91',
            rare        : 'SR',
            name        : 'おはないっぱいおしょうがつだいだいトップス',
            imgUrl      : '/images/items/PCH5-91.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-92',
            rare        : 'SR',
            name        : 'おはないっぱいおしょうがつだいだいパンツ',
            imgUrl      : '/images/items/PCH5-92.png',
            kind        : 'ボトムス',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-93',
            rare        : 'SR',
            name        : 'おはないっぱいおしょうがつだいだいシューズ',
            imgUrl      : '/images/items/PCH5-93.png',
            kind        : 'シューズ',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-94',
            rare        : 'SR',
            name        : 'おはないっぱいおしょうがつだいだいヘアアクセ',
            imgUrl      : '/images/items/PCH5-94.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'SH',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 7 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-95',
            rare        : 'SR',
            name        : 'あけおめキュートワンピ',
            imgUrl      : '/images/items/PCH5-95.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1200,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-96',
            rare        : 'SR',
            name        : 'あけおめキュートシューズ',
            imgUrl      : '/images/items/PCH5-96.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-97',
            rare        : 'SR',
            name        : 'あけおめキュートヘアアクセ',
            imgUrl      : '/images/items/PCH5-97.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつコーデキャンペーン',
            rare        : 'SR',
          }),


          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-98',
            rare        : 'SR',
            name        : 'スパーキング☆フォックストップス',
            imgUrl      : '/images/items/PCH5-98.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-99',
            rare        : 'SR',
            name        : 'スパーキング☆フォックススカート',
            imgUrl      : '/images/items/PCH5-99.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-100',
            rare        : 'SR',
            name        : 'スパーキング☆フォックスシューズ',
            imgUrl      : '/images/items/PCH5-100.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'おしょうがつコーデキャンペーン',
            id          : 'PCH5-101',
            rare        : 'SR',
            name        : 'スパーキング☆フォックスヘアアクセ',
            imgUrl      : '/images/items/PCH5-101.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] ウィンタースペシャル大会
          // ================================================================================

          item({
            collection  : 'ウィンタースペシャル大会',
            id          : 'SP-013',
            rare        : 'SR',
            name        : 'シャイニースターオーロラトップス',
            imgUrl      : '/images/items/SP-013.png',
            kind        : 'トップス',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : '800',
            numOwned    : { usual: 6 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ウィンタースペシャル大会',
            id          : 'SP-014',
            rare        : 'SR',
            name        : 'シャイニースターオーロラスカート',
            imgUrl      : '/images/items/SP-014.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'PM',
            type        : 'PR',
            point       : '750',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ウィンタースペシャル大会',
            id          : 'SP-015',
            rare        : 'SR',
            name        : 'シャイニースターオーロラシューズ',
            imgUrl      : '/images/items/SP-015.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'PM',
            type        : 'PR',
            point       : '700',
            numOwned    : { usual: 9 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ウィンタースペシャル大会',
            id          : 'SP-016',
            rare        : 'SR',
            name        : 'シャイニースターオーロラヘアアクセ',
            imgUrl      : '/images/items/SP-016.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'PM',
            type        : 'PR',
            point       : '700',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] メルティックスターセレクション
          // ================================================================================

          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-01',
            rare        : 'PR',
            name        : 'はなのプリパリルージュトップス',
            imgUrl      : '/images/items/SL5-01.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-02',
            rare        : 'PR',
            name        : 'はなのプリパリルージュパンツ',
            imgUrl      : '/images/items/SL5-02.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-03',
            rare        : 'PR',
            name        : 'はなのプリパリルージュシューズ',
            imgUrl      : '/images/items/SL5-03.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-04',
            rare        : 'PR',
            name        : 'はなのプリパリルージュヘアアクセ',
            imgUrl      : '/images/items/SL5-04.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-05',
            rare        : 'PR',
            name        : 'キューティーキャッツピンクトップス',
            imgUrl      : '/images/items/SL5-05.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-06',
            rare        : 'PR',
            name        : 'キューティーキャッツピンクパンツ',
            imgUrl      : '/images/items/SL5-06.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 850,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-07',
            rare        : 'PR',
            name        : 'キューティーキャッツピンクシューズ',
            imgUrl      : '/images/items/SL5-07.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-08',
            rare        : 'PR',
            name        : 'キューティーキャッツピンクヘアアクセ',
            imgUrl      : '/images/items/SL5-08.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-09',
            rare        : 'SR',
            name        : 'ぶとうかいシネマワンピ',
            imgUrl      : '/images/items/SL5-09.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 1200,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-10',
            rare        : 'SR',
            name        : 'ぶとうかいシネマシューズ',
            imgUrl      : '/images/items/SL5-10.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-11',
            rare        : 'SR',
            name        : 'ぶとうかいシネマヘアアクセ',
            imgUrl      : '/images/items/SL5-11.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            rare        : 'SR',
          }),


          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-12',
            rare        : 'SR',
            name        : 'ロックスタイルレディトップスS',
            imgUrl      : '/images/items/SL5-12.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-13',
            rare        : 'SR',
            name        : 'ロックスタイルレディパンツS',
            imgUrl      : '/images/items/SL5-13.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-14',
            rare        : 'SR',
            name        : 'ロックスタイルレディブーツS',
            imgUrl      : '/images/items/SL5-14.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-15',
            rare        : 'SR',
            name        : 'ロックスタイルヘアアクセS',
            imgUrl      : '/images/items/SL5-15.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-16',
            rare        : 'SR',
            name        : 'ゴージャスパールドレス',
            imgUrl      : '/images/items/SL5-16.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1200,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-17',
            rare        : 'SR',
            name        : 'ゴージャスパールシューズ',
            imgUrl      : '/images/items/SL5-17.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-18',
            rare        : 'SR',
            name        : 'ゴージャスパールヘアアクセ',
            imgUrl      : '/images/items/SL5-18.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            rare        : 'SR',
          }),


          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-19',
            rare        : 'R',
            name        : 'チャイナロックワンピ',
            imgUrl      : '/images/items/SL5-19.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({

            collection  : 'メルティックスターセレクション',
            id          : 'SL5-20',
            rare        : 'R',
            name        : 'チャイナロックブーツ',
            imgUrl      : '/images/items/SL5-20.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-21',
            rare        : 'R',
            name        : 'チャイナロックヘアアクセ',
            imgUrl      : '/images/items/SL5-21.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            rare        : 'R',
          }),


          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-22',
            rare        : 'R',
            name        : 'ブリティッシュロックレッドグリーントップス',
            imgUrl      : '/images/items/SL5-22.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-23',
            rare        : 'R',
            name        : 'ブリティッシュロックレッドグリーンスカート',
            imgUrl      : '/images/items/SL5-23.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-24',
            rare        : 'R',
            name        : 'ブリティッシュロックレッドグリーンシューズ',
            imgUrl      : '/images/items/SL5-24.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-25',
            rare        : 'R',
            name        : 'ブリティッシュロックレッドグリーンヘアアクセ',
            imgUrl      : '/images/items/SL5-25.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-26',
            rare        : 'R',
            name        : 'ひょうがらデニムトップス',
            imgUrl      : '/images/items/SL5-26.png',
            kind        : 'トップス',
            color       : '茶',
            brand       : '',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-27',
            rare        : 'R',
            name        : 'ひょうがらデニムスカート',
            imgUrl      : '/images/items/SL5-27.png',
            kind        : 'ボトムス',
            color       : '茶',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-28',
            rare        : 'R',
            name        : 'ひょうがらデニムシューズ',
            imgUrl      : '/images/items/SL5-28.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-29',
            rare        : 'R',
            name        : 'ひょうがらデニムヘアアクセ',
            imgUrl      : '/images/items/SL5-29.png',
            kind        : 'ヘアアクセ',
            color       : '茶',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-30',
            rare        : 'R',
            name        : 'メリーゴーランドフラワートップス',
            imgUrl      : '/images/items/SL5-30.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-31',
            rare        : 'R',
            name        : 'メリーゴーランドフラワースカート',
            imgUrl      : '/images/items/SL5-31.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-32',
            rare        : 'R',
            name        : 'メリーゴーランドフラワーシューズ',
            imgUrl      : '/images/items/SL5-32.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 550,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'メルティックスターセレクション',
            id          : 'SL5-33',
            rare        : 'R',
            name        : 'メリーゴーランドフラワーヘアアクセ',
            imgUrl      : '/images/items/SL5-33.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 450,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] らぁらチャンネル
          // ================================================================================

          item({
            collection  : 'らぁらチャンネル',
            id          : 'SL5-77',
            rare        : 'SR',
            name        : 'ウィッシュリボンアイドルブラウスL',
            imgUrl      : '/images/items/SL5-77.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁらチャンネル',
            id          : 'SL5-78',
            rare        : 'SR',
            name        : 'ウィッシュリボンアイドルスカートL',
            imgUrl      : '/images/items/SL5-78.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁらチャンネル',
            id          : 'SL5-79',
            rare        : 'SR',
            name        : 'ウィッシュリボンアイドルブーツL',
            imgUrl      : '/images/items/SL5-79.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁらチャンネル',
            id          : 'SL5-80',
            rare        : 'SR',
            name        : 'ウィッシュリボンアイドルヘアアクセL',
            imgUrl      : '/images/items/SL5-80.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'らぁらチャンネル',
            id          : 'SL5-81',
            rare        : 'SR',
            name        : 'ドリームTRサイリウムワンピ',
            imgUrl      : '/images/items/SL5-81.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : '1200',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁらチャンネル',
            id          : 'SL5-82',
            rare        : 'SR',
            name        : 'ドリームTRサイリウムシューズ',
            imgUrl      : '/images/items/SL5-82.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁらチャンネル',
            id          : 'SL5-83',
            rare        : 'SR',
            name        : 'ドリームTRサイリウムヘアアクセ',
            imgUrl      : '/images/items/SL5-83.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁらチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'らぁらチャンネル',
            id          : 'SL5-98',
            rare        : 'SR',
            name        : 'クマのぬいぐるみ',
            imgUrl      : '/images/items/SL5-98.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁらチャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'らぁらチャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'らぁらチャンネル',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] ゆいチャンネル
          // ================================================================================

          item({
            collection  : 'ゆいチャンネル',
            id          : 'SL5-84',
            rare        : 'SR',
            name        : 'ファンタジータイムサイリウムワンピ',
            imgUrl      : '/images/items/SL5-84.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '1200',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ゆいチャンネル',
            id          : 'SL5-85',
            rare        : 'SR',
            name        : 'ファンタジータイムサイリウムシューズ',
            imgUrl      : '/images/items/SL5-85.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ゆいチャンネル',
            id          : 'SL5-86',
            rare        : 'SR',
            name        : 'ファンタジータイムサイリウムヘアアクセ',
            imgUrl      : '/images/items/SL5-86.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ゆいチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'ゆいチャンネル',
            id          : 'SL5-87',
            rare        : 'SR',
            name        : 'ラビットハートファンシートップス',
            imgUrl      : '/images/items/SL5-87.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '700',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ゆいチャンネル',
            id          : 'SL5-88',
            rare        : 'SR',
            name        : 'ラビットハートファンシースカート',
            imgUrl      : '/images/items/SL5-88.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '650',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ゆいチャンネル',
            id          : 'SL5-89',
            rare        : 'SR',
            name        : 'ラビットハートファンシーシューズ',
            imgUrl      : '/images/items/SL5-89.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ゆいチャンネル',
            id          : 'SL5-90',
            rare        : 'SR',
            name        : 'ラビットハートファンシーヘアアクセ',
            imgUrl      : '/images/items/SL5-90.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : 'ゆいチャンネル',
            id          : 'SL5-99',
            rare        : 'SR',
            name        : 'プニコンのぬいぐるみ',
            imgUrl      : '/images/items/SL5-99.png',
            kind        : 'パシャッとアイテム',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'ゆいチャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'ゆいチャンネル',
            kind        : 'パシャッとアイテム',
          }),
          item({
            collection  : 'ゆいチャンネル',
            kind        : 'パシャッとアイテム',
          }),


          // [NOTE] らぁら＆ゆいチャンネル
          // ================================================================================

          item({
            collection  : 'らぁら＆ゆいチャンネル',
            id          : 'SL5-91',
            rare        : 'SR',
            name        : 'SoLaMi♡SMILEチームサイリウムワンピL',
            imgUrl      : '/images/items/SL5-91.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '1200',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁら＆ゆいチャンネル',
            id          : 'SL5-92',
            rare        : 'SR',
            name        : 'SoLaMi♡SMILEチームサイリウムシューズL',
            imgUrl      : '/images/items/SL5-92.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁら＆ゆいチャンネル',
            id          : 'SL5-93',
            rare        : 'SR',
            name        : 'SoLaMi♡SMILEチームサイリウムヘアアクセL',
            imgUrl      : '/images/items/SL5-93.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁら＆ゆいチャンネル',
            rare        : 'SR',
          }),


          item({
            collection  : 'らぁら＆ゆいチャンネル',
            id          : 'SL5-94',
            rare        : 'SR',
            name        : 'マジカる☆スターピンクトップス',
            imgUrl      : '/images/items/SL5-94.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '700',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁら＆ゆいチャンネル',
            id          : 'SL5-95',
            rare        : 'SR',
            name        : 'マジカる☆スターピンクスカート',
            imgUrl      : '/images/items/SL5-95.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '650',
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁら＆ゆいチャンネル',
            id          : 'SL5-96',
            rare        : 'SR',
            name        : 'マジカる☆スターピンクシューズ',
            imgUrl      : '/images/items/SL5-96.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : 'らぁら＆ゆいチャンネル',
            id          : 'SL5-97',
            rare        : 'SR',
            name        : 'マジカる☆スターピンクヘアアクセ',
            imgUrl      : '/images/items/SL5-97.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : '600',
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          // [NOTE] 福袋
          // ================================================================================

          item({
            collection  : '福袋',
            id          : 'SL5-34',
            rare        : 'SR',
            name        : 'スーパーサイリウムファルルラベンダーワンピ',
            imgUrl      : '/images/items/SL5-34.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 1200,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-35',
            rare        : 'SR',
            name        : 'スーパーサイリウムファルルラベンダーシューズ',
            imgUrl      : '/images/items/SL5-35.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-36',
            rare        : 'SR',
            name        : 'スーパーサイリウムファルルラベンダーヘアアクセ',
            imgUrl      : '/images/items/SL5-36.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            rare        : 'SR',
          }),



          item({
            collection  : '福袋',
            id          : 'SL5-37',
            rare        : 'SR',
            name        : 'フラワーメレンゲトップス',
            imgUrl      : '/images/items/SL5-37.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-38',
            rare        : 'SR',
            name        : 'フラワーメレンゲスカート',
            imgUrl      : '/images/items/SL5-38.png',
            kind        : 'スカート',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-39',
            rare        : 'SR',
            name        : 'フラワーメレンゲブーツ',
            imgUrl      : '/images/items/SL5-39.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-40',
            rare        : 'SR',
            name        : 'フラワーメレンゲヘアアクセ',
            imgUrl      : '/images/items/SL5-40.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '福袋',
            id          : 'SL5-41',
            rare        : 'SR',
            name        : 'マジカルピエロトップス',
            imgUrl      : '/images/items/SL5-41.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-42',
            rare        : 'SR',
            name        : 'マジカルピエロスカート',
            imgUrl      : '/images/items/SL5-42.png',
            kind        : 'スカート',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-43',
            rare        : 'SR',
            name        : 'マジカルピエロシューズ',
            imgUrl      : '/images/items/SL5-43.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-44',
            rare        : 'SR',
            name        : 'マジカルピエロヘアアクセ',
            imgUrl      : '/images/items/SL5-44.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '福袋',
            id          : 'SL5-45',
            rare        : 'SR',
            name        : 'ホワイトスワントップス',
            imgUrl      : '/images/items/SL5-45.png',
            kind        : 'トップス',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-46',
            rare        : 'SR',
            name        : 'ホワイトスワンパニエ',
            imgUrl      : '/images/items/SL5-46.png',
            kind        : 'スカート',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-47',
            rare        : 'SR',
            name        : 'ホワイトスワンシューズ',
            imgUrl      : '/images/items/SL5-47.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-48',
            rare        : 'SR',
            name        : 'ホワイトスワンヘアアクセ',
            imgUrl      : '/images/items/SL5-48.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '福袋',
            id          : 'SL5-49',
            rare        : 'SR',
            name        : 'フレッシュマーチングスタージャケット',
            imgUrl      : '/images/items/SL5-49.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-50',
            rare        : 'SR',
            name        : 'フレッシュマーチングスタースカート',
            imgUrl      : '/images/items/SL5-50.png',
            kind        : 'スカート',
            color       : '桃',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-51',
            rare        : 'SR',
            name        : 'フレッシュマーチングスターブーツ',
            imgUrl      : '/images/items/SL5-51.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-52',
            rare        : 'SR',
            name        : 'フレッシュマーチングスターヘアアクセ',
            imgUrl      : '/images/items/SL5-52.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '福袋',
            id          : 'SL5-53',
            rare        : 'SR',
            name        : 'ツインギンガムトップス',
            imgUrl      : '/images/items/SL5-53.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-54',
            rare        : 'SR',
            name        : 'ツインギンガムスカート',
            imgUrl      : '/images/items/SL5-54.png',
            kind        : 'スカート',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-55',
            rare        : 'SR',
            name        : 'ツインギンガムシューズ',
            imgUrl      : '/images/items/SL5-55.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-56',
            rare        : 'SR',
            name        : 'ツインギンガムヘアアクセ',
            imgUrl      : '/images/items/SL5-56.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '福袋',
            id          : 'SL5-57',
            rare        : 'SR',
            name        : 'マリオネットミューサイリウムワンピ',
            imgUrl      : '/images/items/SL5-57.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1200,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-58',
            rare        : 'SR',
            name        : 'マリオネットミューサイリウムシューズ',
            imgUrl      : '/images/items/SL5-58.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-59',
            rare        : 'SR',
            name        : 'マリオネットミューサイリウムヘアアクセ',
            imgUrl      : '/images/items/SL5-59.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            rare        : 'SR',
          }),


          item({
            collection  : '福袋',
            id          : 'SL5-60',
            rare        : 'SR',
            name        : 'エンジェリックファンシートップス',
            imgUrl      : '/images/items/SL5-60.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-61',
            rare        : 'SR',
            name        : 'エンジェリックファンシースカート',
            imgUrl      : '/images/items/SL5-61.png',
            kind        : 'スカート',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-62',
            rare        : 'SR',
            name        : 'エンジェリックファンシーシューズ',
            imgUrl      : '/images/items/SL5-62.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-63',
            rare        : 'SR',
            name        : 'エンジェリックファンシーヘアアクセ',
            imgUrl      : '/images/items/SL5-63.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '福袋',
            id          : 'SL5-64',
            rare        : 'SR',
            name        : 'DressingPafeチームサイリウムワンピS',
            imgUrl      : '/images/items/SL5-64.png',
            kind        : 'ワンピース',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 1200,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-65',
            rare        : 'SR',
            name        : 'DressingPafeチームサイリウムシューズS',
            imgUrl      : '/images/items/SL5-65.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-66',
            rare        : 'SR',
            name        : 'DressingPafeチームサイリウムヘアアクセS',
            imgUrl      : '/images/items/SL5-66.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            rare        : 'SR',
          }),


          item({
            collection  : '福袋',
            id          : 'SL5-67',
            rare        : 'SR',
            name        : 'ウィッシュリボンアイドルブラウスM',
            imgUrl      : '/images/items/SL5-67.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 700,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-68',
            rare        : 'SR',
            name        : 'ウィッシュリボンアイドルスカートM',
            imgUrl      : '/images/items/SL5-68.png',
            kind        : 'パンツ',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-69',
            rare        : 'SR',
            name        : 'ウィッシュリボンアイドルブーツM',
            imgUrl      : '/images/items/SL5-69.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-70',
            rare        : 'SR',
            name        : 'ウィッシュリボンアイドルヘアアクセM',
            imgUrl      : '/images/items/SL5-70.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),


          item({
            collection  : '福袋',
            id          : 'SL5-71',
            rare        : 'SR',
            name        : 'クリスタルローズビジュートップス',
            imgUrl      : '/images/items/SL5-71.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-72',
            rare        : 'SR',
            name        : 'クリスタルローズビジュードレス',
            imgUrl      : '/images/items/SL5-72.png',
            kind        : 'スカート',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-73',
            rare        : 'SR',
            name        : 'クリスタルローズビジューヒール',
            imgUrl      : '/images/items/SL5-73.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 600,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            rare        : 'SR',
          }),


          item({
            collection  : '福袋',
            id          : 'SL5-74',
            rare        : 'SR',
            name        : 'エメラルドアラブトップス',
            imgUrl      : '/images/items/SL5-74.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'PR',
            point       : 700,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-75',
            rare        : 'SR',
            name        : 'エメラルドアラブショーパン',
            imgUrl      : '/images/items/SL5-75.png',
            kind        : 'スカート',
            color       : '緑',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            id          : 'SL5-76',
            rare        : 'SR',
            name        : 'エメラルドアラブパンプス',
            imgUrl      : '/images/items/SL5-76.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
          }),
          item({
            collection  : '福袋',
            rare        : 'SR',
          }),
        ],
      }
    },

    computed: {
      itemsFiltered () {
        const { excepts, items } = this
        return excepts.length
          ? items.filter(item => !excepts.includes(item.collection) )
          : items
      },

      itemsMaJor () {
        const { major, itemsFiltered, itemsPasha } = this
        return itemsFiltered.filter(item => major.includes(item.collection) && !itemsPasha.includes(item))
      },

      itemsKR () {
        return _.where(this.itemsMaJor, { rare: 'KR' })
      },

      itemsPR () {
        return _.where(this.itemsMaJor, { rare: 'PR' })
      },

      itemsSR () {
        return _.where(this.itemsMaJor, { rare: 'SR' })
      },

      itemsR () {
        return _.where(this.itemsMaJor, { rare: 'R' })
      },

      itemsN () {
        return _.where(this.itemsMaJor, { rare: 'N' })
      },

      itemsPasha () {
        return _.where(this.itemsFiltered, { kind: 'パシャッとアイテム' }).filter(item => this.major.includes(item.collection) )
      },

      itemsSAChannel () {
        return _.where(this.itemsFiltered, { collection: 'Secret Alice チャンネル' })
      },

      itemsUQChannel () {
        return _.where(this.itemsFiltered, { collection: 'Universe Queen チャンネル' })
      },

      itemsPMChannel () {
        return _.where(this.itemsFiltered, { collection: 'Precious Muse チャンネル' })
      },

      itemsNakayoshiChannel () {
        return _.where(this.itemsFiltered, { collection: 'なかよしチャンネル' })
      },

      itemsMolly () {
        return _.where(this.itemsFiltered, { collection: 'モーリーファンタジー限定' })
      },

      itemsMMPures () {
        return _.where(this.itemsFiltered, { collection: 'マジマジョピュアーズ！コラボ' })
      },

      itemsKirby () {
        return _.where(this.itemsFiltered, { collection: '星のカービィコラボ' })
      },

      itemsXmas () {
        return _.where(this.itemsFiltered, { collection: 'クリスマスコーデキャンペーン' })
      },

      itemsNewYear () {
        return _.where(this.itemsFiltered, { collection: 'おしょうがつコーデキャンペーン' })
      },

      itemsWinterSp () {
        return _.where(this.itemsFiltered, { collection: 'ウィンタースペシャル大会' })
      },

      itemsLaala () {
        return _.where(this.itemsFiltered, { collection: 'らぁらチャンネル' })
      },

      itemsYui () {
        return _.where(this.itemsFiltered, { collection: 'ゆいチャンネル' })
      },

      itemsLaalaYui () {
        return _.where(this.itemsFiltered, { collection: 'らぁら＆ゆいチャンネル' })
      },

      itemsMeltic () {
        return _.where(this.itemsFiltered, { collection: 'メルティックスターセレクション' })
      },

      itemsMelticPR () {
        return _.where(this.itemsMeltic, { rare: 'PR' })
      },

      itemsMelticSR () {
        return _.where(this.itemsMeltic, { rare: 'SR' })
      },

      itemsMelticR () {
        return _.where(this.itemsMeltic, { rare: 'R' })
      },

      itemsLuckyBag () {
        return _.where(this.itemsFiltered, { collection: '福袋' })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="KR ★★★★" color="#ff5d91" :items="itemsKR" />
    </template>

    <template #col2>
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
      <ItemList title="PR モーリー限定 ★★★" color="#55b272" :items="itemsMolly" />
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
    </template>

    <template #col3>
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
    </template>

    <template #col4>
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="なかよしチャンネル" color="#c598ff" :items="itemsNakayoshiChannel" />
      <ItemList title="Secret Alice チャンネル" color="#c598ff" :items="itemsSAChannel" />
      <ItemList title="Universe Queen チャンネル" color="#c598ff" :items="itemsUQChannel" />
      <ItemList title="Precious Muse チャンネル" color="#c598ff" :items="itemsPMChannel" />
    </template>

    <template #col5>
      <ItemList title="ウィンタースペシャル大会" color="#a1c0fa" :items="itemsWinterSp" />
      <ItemList title="マジマジョピュアーズ！コラボ" color="#a1c0fa" :items="itemsMMPures" />
      <ItemList title="星のカービィコラボ" color="#a1c0fa" :items="itemsKirby" />
      <ItemList title="クリスマスコーデキャンペーン" color="#a1c0fa" :items="itemsXmas" />
      <ItemList title="おしょうがつコーデキャンペーン" color="#a1c0fa" :items="itemsNewYear" />
    </template>

    <template #col6>
      <ItemList title="メルスタセレクション PR" color="#ffa1bc" :items="itemsMelticPR" />
      <ItemList title="メルスタセレクション SR" color="#00c7da" :items="itemsMelticSR" />
      <ItemList title="メルスタセレクション R" color="#feab0d" :items="itemsMelticR" />
    </template>

    <template #col7>
      <ItemList title="らぁらチャンネル" color="#a1c0fa" :items="itemsLaala" />
      <ItemList title="ゆいチャンネル" color="#a1c0fa" :items="itemsYui" />
      <ItemList title="らぁら＆ゆいチャンネル" color="#a1c0fa" :items="itemsLaalaYui" />
    </template>

    <template #col8>
    </template>

    <template #col9>
      <ItemList title="福袋" color="#00c7da" :items="itemsLuckyBag" />
      <Status :date="date" :items="items" :showKira="true" :showKR="true" />
    </template>

    <template #col10>
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // コレクショングループ間の間隔 (KR)
  .Page ::v-deep .Page__col:nth-child(1) .ItemList:nth-child(1) {
    .Item:nth-child(5),
    .Item:nth-child(6),
    .Item:nth-child(7),
    .Item:nth-child(8) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (PR)
  .Page ::v-deep .Page__col:nth-child(2) .ItemList:nth-child(1) {
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (SR)
  .Page ::v-deep .Page__col:nth-child(2) .ItemList:nth-child(3) {
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12) {
      margin-top: $size-unit * 8;
    }
  }

  // コレクショングループ間の間隔 (パシャテム)
  .Page ::v-deep .Page__col:nth-child(4) .ItemList:nth-child(1) {
    .Item:nth-child(5),
    .Item:nth-child(6),
    .Item:nth-child(7),
    .Item:nth-child(8),
    .Item:nth-child(9),
    .Item:nth-child(10),
    .Item:nth-child(11),
    .Item:nth-child(12) {
      margin-top: $size-unit * 8;
    }
  }

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
